// src/pages/AccountPage.tsx
import React from 'react';
import { Box } from '@mui/material';
import UserAccountInfo from '../components/authentication/UserAccountInfo';
import AccountsTable from '../components/authentication/AccountsTable';
import AccountModal from '../components/authentication/AccountModal';
import ChangePasswordModal from '../components/authentication/ChangePasswordModal';
import RoleBasedAccess from '../services/RoleBasedAccess';
import { AccountProvider, useAccountContext } from '../context/AccountContext';

const AccountPageContent: React.FC = () => {
  const { showSignUp, selectedAccount, isChangePasswordOpen, closeModal, setIsChangePasswordOpen } = useAccountContext();

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      height: '100%', 
      minHeight: 0, 
      padding: 2,
      overflow: 'hidden' 
    }}>
      <UserAccountInfo />
      <RoleBasedAccess allowedRoles={["Admin", "Support"]}>
        <AccountsTable />
      </RoleBasedAccess>
      <AccountModal open={showSignUp} onClose={closeModal} account={selectedAccount} />
      <ChangePasswordModal
        open={isChangePasswordOpen}
        onClose={() => setIsChangePasswordOpen(false)}
      />
    </Box>
  );
}

const AccountPage: React.FC = () => {
  return (
    <AccountProvider>
      <AccountPageContent />
    </AccountProvider>
  );
};

export default AccountPage;